import Application from '@ember/application';
import { importSync, isDevelopingApp, macroCondition } from '@embroider/macros';
import * as Sentry from '@sentry/ember';
import 'walden-trace-app/app.css';
import config from 'walden-trace-app/config/environment';
import Resolver from 'ember-resolver';

if (config.sentry.isEnabled) {
  Sentry.init(config.sentry.options);
}

if (macroCondition(isDevelopingApp())) {
  importSync('./deprecation-workflow');
}

export default class App extends Application {
  modulePrefix = config.modulePrefix;
  Resolver = Resolver;
}
